import styled from '@emotion/styled'

import { mobile, maxDeviceWidth, customDevice } from '../../../utils/mixins'
import { Typo24PumpkinOrangeDINDI } from '../../../themes/Fonts/Din2014'
import { Type36WhiteNBI } from '../../../themes/Fonts/Nort'

export const Container = styled.div`
  background-image: url('https://res.cloudinary.com/due4dmz2b/image/fetch/dpr_auto,w_auto,f_auto,q_auto/https://proyuga-media-assets.s3.ap-south-1.amazonaws.com/experiential-marketing/v2/experiential-marketing-desktop-background.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #000000;
  padding-top: 163px;
  padding-bottom: 163px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  ${maxDeviceWidth(767)} {
    padding-top: 240px;
    padding-bottom: 47px;
    background-image: url('https://res.cloudinary.com/due4dmz2b/image/fetch/dpr_auto,w_auto,f_auto,q_auto/https://proyuga-media-assets.s3.ap-south-1.amazonaws.com/experiential-marketing/v2/experiential-marketing-mobile-background.png');
    background-repeat: no-repeat;
    background-size: cover;
  }
`

export const ResponsiveContainer = styled.div`
  width: 1124px;
  margin: auto;
  display: flex;
  flex-direction: column;

  ${mobile} {
    width: 88.8%;
  }

  ${customDevice(768, 959)} {
    width: 90%;
  }

  ${customDevice(960, 1200)} {
    width: 90%;
  }
`

export const Heading = styled(Type36WhiteNBI)`
  line-height: 1.5;
  letter-spacing: 1px;
  margin-bottom: 20px;
  margin-top: 10px;

  ${maxDeviceWidth(767)} {
    display: none;
  }
`

export const MobileHeading = styled(Type36WhiteNBI)`
  display: none;

  ${maxDeviceWidth(767)} {
    display: block;
    line-height: 1.67;
    letter-spacing: 0.45px;
    margin-bottom: 32px;
    font-size: 24px;
  }
`

export const Description = styled(Typo24PumpkinOrangeDINDI)`
 letter-spacing: 0.6px
 line-height: normal;
 margin-bottom: 50px;
 text-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

 ${maxDeviceWidth(767)}
 { letter-spacing: 0.4px;
    font-size: 18px;
    margin-bottom: 29px;
   }
 `

export const NavBar = styled.div`
  height: 95px;
  background: black;
`



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/LandingSection/styledComponents.js